var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLixi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "red-envelope",
    focusable: "false",
    viewBox: "64 64 896 896",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m832 64h-640c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32v-832c0-17.7-14.3-32-32-32zm-40 824h-560v-694.9l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0l260.2-204.1zm0-751.3h-31.7l-248.3 194.6-248.3-194.6h-31.7v-0.7h560z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLixi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_lixi.eb9751bd505665743b51bc8e9ddf525a.svg";